/* Global imports. */
import React from "react";
import { nanoid } from 'nanoid';

/* Model imports. */
import KontentArticleSummary from "@models/kontent/KontentArticleSummary";

/* Component imports. */
import ArticleCard from "@components/ArticleCard";

interface Props {
  title?: string;
  format: "large" | "portrait" | "landscape";
  articleSummaries: Array<{ fields: { slug: string }; elements: KontentArticleSummary }>;
  sectionClass?: string;
  headingClass?: string;
  listClass?: string;
  componentID?: string;
}

const RelatedArticles = ({ title="You may also like",format, articleSummaries, sectionClass, headingClass, listClass, componentID }: Props) => (
  <section id={componentID} data-component="related-articles" className={sectionClass}>
    <h3 className={`mb-[32px] ${headingClass && headingClass}`}>{title}</h3>
    <ul className={listClass}>
      {articleSummaries.slice(0, 6).map((articleSummary, index) => (
        articleSummary.elements && <ArticleCard
          key={nanoid()}
          articleSummary={articleSummary.elements}
          articleURL={articleSummary.fields && articleSummary.fields.slug}
          format={format}
          id={articleSummary.id}
          referringComponentID={componentID}
        />
      ))}
    </ul>
  </section>
);

export default RelatedArticles;
